import React from 'react';
import DictationEditor from './DictationEditor';
import { AuthContextProps, withAuth } from './LocalAuthWrapper';
import { RouteComponentProps, withRouter, useLocation } from 'react-router-dom';
import { SPEECH_API_KEY, SPEECH_SERVICE_HOST, SPEECH_RTG_SERVICE_HOST, TRANSCRIPT_SERVICE_HOST } from './config';

type DraftEditorProps = AuthContextProps & RouteComponentProps;

function DraftEditor(props: DraftEditorProps) {
  const { search } = useLocation();

  const langCode = new URLSearchParams(search).get('langCode');
  const subject = new URLSearchParams(search).get('subject');
  const keywords = new URLSearchParams(search).get('keywords')?.split(',') ?? [];
  const restricted = new URLSearchParams(search).get('restricted') === 'true';
  const speechServerUrlParam = new URLSearchParams(search).get('speechServerUrl');
  const speechServerKey = new URLSearchParams(search).get('speechServerKey');

  const speechServerUrl = speechServerUrlParam
    ? speechServerUrlParam
    : langCode && (langCode.startsWith('is-IS-x-rtg-') || langCode === 'is-IS-x-radiology')
    ? SPEECH_RTG_SERVICE_HOST
    : SPEECH_SERVICE_HOST;

  return (
    <DictationEditor
      initialSubject={subject ?? undefined}
      languageCode={langCode ?? undefined}
      initialKeywords={keywords}
      accessToken={props.authCtx.accessToken!!}
      signOut={props.authCtx.signOut}
      speechServerUrl={speechServerUrl ?? SPEECH_RTG_SERVICE_HOST}
      speechServerKey={speechServerKey ?? SPEECH_API_KEY}
      transcriptServerUrl={TRANSCRIPT_SERVICE_HOST}
      restricted={restricted}
    />
  );
}

export default withAuth(withRouter(DraftEditor));
